import { createContext, useContext } from "react";

type Context = {
  setHeaderActions: (actions: React.ReactNode) => void;
  setSubNavigation: (nav: React.ReactNode) => void;
};

export const PortalPageContext = createContext<Context>({
  setHeaderActions: () => {},
  setSubNavigation: () => {},
});

export const usePortalPage = () => {
  return useContext(PortalPageContext);
};